import { parse, format, isValid } from 'date-fns'

export default {
  formattedPublishDate () {
    const parsed = parse(this.formattedPublishDate, 'dd/MM/yyyy HH:mm', new Date())
    if (isValid(parsed)) {
      this.post.publishDate = format(parsed, 'yyyy-MM-dd HH:mm:ssXX')
    }
  },

  image () {
    const self = this
    if (self.image instanceof File) {
      const reader = new FileReader()

      reader.readAsDataURL(self.image)

      reader.onload = function () {
        self.post.image = reader.result
        self.post.imageFilename = self.image.name
      }
    }
  },

  categorySearchQuery () {
    this.searchCategories(this.categorySearchQuery)
  },
}
